import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "block-searchFilter mt30 mb15" }
const _hoisted_2 = {
  key: 0,
  class: "block-searchFilter__region"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  "data-toggle": "modal",
  "data-target": "#selectCityModal"
}, "сменить", -1 /* HOISTED */)
const _hoisted_4 = { class: "block-searchFilter__input-group" }
const _hoisted_5 = { class: "block-searchFilter__input-group-item" }
const _hoisted_6 = { class: "block-searchFilter__input-group-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "block-searchFilter__input-group-item-subCity"
}
const _hoisted_9 = {
  key: 1,
  class: "block-searchFilter__input-group-item-subCity"
}
const _hoisted_10 = {
  key: 0,
  style: {"padding":"7px"}
}
const _hoisted_11 = { class: "block-searchFilter__input-group-item" }
const _hoisted_12 = {
  key: 0,
  class: "shutdown-list__title"
}
const _hoisted_13 = {
  key: 2,
  id: "incident-list"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 col-md-7" }
const _hoisted_16 = { class: "block-incidentcard__info" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "block-incidentcard__type" }
const _hoisted_19 = { class: "block-incidentcard__work" }
const _hoisted_20 = { class: "block-incidentcard__description" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Номер события:", -1 /* HOISTED */)
const _hoisted_22 = { class: "block-incidentcard__org" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "В период:", -1 /* HOISTED */)
const _hoisted_24 = { class: "block-incidentcard__date" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "Ответственный исполнитель:", -1 /* HOISTED */)
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "col-lg-6 col-md-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "По адресам:", -1 /* HOISTED */)
const _hoisted_29 = { class: "block-textMin mb10" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Observer = _resolveComponent("Observer")!
  const _component_loader = _resolveComponent("loader")!
  const _component_WorkListSkeleton = _resolveComponent("WorkListSkeleton")!
  const _component_alert_search = _resolveComponent("alert-search")!
  const _component_paginate = _resolveComponent("paginate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($data.selectCityModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString($data.areaActive) + ", " + _toDisplayString($data.cityActive) + " ", 1 /* TEXT */),
            _hoisted_3
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_select, {
            modelValue: $data.selectedCity,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedCity) = $event)),
            label: "name",
            options: $data.cities,
            "onOption:selected": $options.onStreets,
            clearable: false,
            placeholder: "Населенный пункт"
          }, {
            "no-options": _withCtx(() => [
              _createTextVNode(_toDisplayString($data.noOptionText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "options", "onOption:selected"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_select, {
            modelValue: $data.selectedStreet,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.selectedStreet) = $event)),
            loading: $data.loadStreet,
            label: "full_name",
            placeholder: "Введите улицу",
            "deselect-from-dropdown": true,
            clearable: true,
            filterable: false,
            options: $data.streets,
            onSearch: $options.debounceSearch,
            onOpen: _cache[2] || (_cache[2] = ($event: any) => ($data.selectedHouse = null))
          }, {
            option: _withCtx(({ city_name, full_name, sub_сity }) => [
              _createTextVNode(_toDisplayString(full_name), 1 /* TEXT */),
              _hoisted_7,
              (this.selectedCity.id === '' && sub_сity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(sub_сity.name), 1 /* TEXT */))
                : (this.selectedCity.id === '' && city_name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(city_name), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
            ]),
            "list-footer": _withCtx(() => [
              _createVNode(_component_Observer, { onIntersect: $options.intersected }, null, 8 /* PROPS */, ["onIntersect"]),
              (this.countPageStreet >= this.pageStreet && this.streets.length >= this.objectsCountStreet)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, " Загрузка... "))
                : _createCommentVNode("v-if", true)
            ]),
            "no-options": _withCtx(() => [
              _createTextVNode(_toDisplayString($data.noOptionText), 1 /* TEXT */)
            ]),
            spinner: _withCtx(({ loading }) => [
              loading
                ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "loading", "options", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_v_select, {
            disabled: this.selectedStreet===null,
            modelValue: $data.selectedHouse,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.selectedHouse) = $event)),
            label: "name",
            placeholder: "Введите номер дома",
            clearable: true,
            options: $data.houses
          }, {
            "no-options": _withCtx(() => [
              _createTextVNode(_toDisplayString($data.noOptionText), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "modelValue", "options"])
        ])
      ])
    ]),
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_WorkListSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($props.showTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment().format('LL')), 1 /* TEXT */),
                _createTextVNode("  проводится и запланировано работ: " + _toDisplayString(this.totalCount), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          ($options.shouldShowAlert)
            ? (_openBlock(), _createBlock(_component_alert_search, {
                key: 1,
                title: 'Ремонтные работы не проводятся'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" В данный момент на территории города не проводятся ремонтные работы и отсутствуют аварийные отключения ")
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.incidents, (incident) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: incident.index,
                    class: "block-incidentcard"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: incident.icon,
                            class: "block-incidentcard__icon"
                          }, null, 8 /* PROPS */, _hoisted_17),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(incident.title), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(incident.subtitle), 1 /* TEXT */),
                          _createElementVNode("div", {
                            class: "block-incidentcard__status",
                            style: _normalizeStyle({background: `#${incident.status.color}`})
                          }, _toDisplayString(incident.status.title), 5 /* TEXT, STYLE */),
                          _createElementVNode("p", _hoisted_20, _toDisplayString(incident.description), 1 /* TEXT */),
                          _hoisted_21,
                          _createElementVNode("p", _hoisted_22, _toDisplayString(incident.number), 1 /* TEXT */),
                          _hoisted_23,
                          _createElementVNode("p", _hoisted_24, " c " + _toDisplayString(_ctx.moment.unix(incident.date.start).format('LLL')) + " " + _toDisplayString(incident.date.end !== null ? `по ${_ctx.moment.unix(incident.date.end).format('LLL')}` : 'до устранения'), 1 /* TEXT */),
                          _hoisted_25,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incident.contractors, (contractor) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: contractor.index,
                              class: "block-incidentcard__org"
                            }, [
                              _createTextVNode(_toDisplayString(contractor.name) + " ", 1 /* TEXT */),
                              (contractor.phones)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" тел.: "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractor.phones, (phone) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: phone.index,
                                        href: `tel: ${ phone.number }`
                                      }, [
                                        _createTextVNode(_toDisplayString(phone.number) + " ", 1 /* TEXT */),
                                        (phone.comment)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" (" + _toDisplayString(phone.comment) + ") ", 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_26))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _hoisted_28,
                          (incident.location.groupedHousesNumByConglomeration.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(incident.location.groupedHousesNumByConglomeration, (conglomeration) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: conglomeration.index
                                }, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("strong", null, _toDisplayString(conglomeration.fullName) + ":", 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("p", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conglomeration.streets, (street) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        _createTextVNode(_toDisplayString(street.name) + ": д. " + _toDisplayString(street.houses.join(', д. ')), 1 /* TEXT */),
                                        _hoisted_30
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            : (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incident.location.groupedHousesNumByStreet, (street) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: street.index
                                  }, [
                                    _createTextVNode(_toDisplayString(street.name) + ": " + _toDisplayString(street.houses.join(', ')), 1 /* TEXT */),
                                    _hoisted_32
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("a", {
                          href: `/incident/${incident.location.city.latin}/${incident.urlName}-${incident.id}`,
                          class: "block-incidentcard__readmore"
                        }, " Подробнее ", 8 /* PROPS */, _hoisted_34)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
        ], 64 /* STABLE_FRAGMENT */)),
    ($options.showPagination && $data.showVueListIncident)
      ? (_openBlock(), _createBlock(_component_paginate, {
          key: $data.paginationKey,
          value: $data.currentPage,
          "page-count": $options.pageCount,
          "page-range": 5,
          "margin-pages": 1,
          "click-handler": $options.onPageChange,
          "prev-text": 'Назад',
          "next-text": 'Дальше',
          "container-class": 'pagination-vue',
          "page-class": 'pagination-vue__item'
        }, null, 8 /* PROPS */, ["value", "page-count", "click-handler"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}